import { Mode, tokens, fonts } from "./theme";
import { useLanguage } from "@/contexts/LanguageContext";

interface Props { mode?: Mode }

const LessonMockup = ({ mode = "dark" }: Props) => {
  const T = tokens(mode);
  const { t } = useLanguage();

  const options = [
    { letter: "A", titleKey: "mock.lesson.optA.title", subKey: "mock.lesson.optA.sub" },
    { letter: "B", titleKey: "mock.lesson.optB.title", subKey: "mock.lesson.optB.sub" },
    { letter: "C", titleKey: "mock.lesson.optC.title", subKey: "mock.lesson.optC.sub" },
  ];

  const stats = [
    { label: t("mock.lesson.statKonto"), value: "CHF 3'240", color: T.text },
    { label: t("mock.lesson.statOffen"), value: "CHF 1'480", color: T.coral },
    { label: t("mock.lesson.statFrei"), value: "CHF 1'760", color: T.accent },
  ];

  return (
    <div style={{ background: T.bg, color: T.text, fontFamily: fonts.ui, height: "100%", padding: "56px 20px 28px", overflowY: "auto" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 22 }}>
        <button style={{ width: 32, height: 32, borderRadius: 10, border: "none", background: T.surface, color: T.text, fontSize: 14, cursor: "pointer" }}>←</button>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 9, color: T.textDim, letterSpacing: 1.2, textTransform: "uppercase", fontWeight: 600 }}>{t("mock.lesson.chapter")}</div>
          <div style={{ height: 3, background: T.surface2, borderRadius: 999, marginTop: 5, overflow: "hidden" }}>
            <div style={{ width: "62%", height: "100%", background: T.accent }} />
          </div>
        </div>
        <span style={{ background: T.coral, color: "#0E1114", fontSize: 9, fontWeight: 700, letterSpacing: 0.5, padding: "5px 10px", borderRadius: 999 }}>{t("mock.lesson.scenarioBadge")}</span>
      </div>

      <div style={{ fontSize: 10, color: T.accent, letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600, marginBottom: 8 }}>{t("mock.lesson.eyebrow")}</div>

      <h2 style={{ fontFamily: fonts.display, fontSize: 30, fontWeight: 400, letterSpacing: -0.8, lineHeight: 1.0, margin: "0 0 16px", fontStyle: "italic" }}>
        {t("mock.lesson.headlinePart1")} <span style={{ color: T.coral }}>{t("mock.lesson.headlinePart2")}</span>
      </h2>

      <p style={{ fontSize: 12, color: T.textDim, lineHeight: 1.55, margin: "0 0 18px" }}>{t("mock.lesson.body")}</p>

      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "12px 14px", marginBottom: 18, display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
        {stats.map((s, i) => (
          <div key={i}>
            <div style={{ fontSize: 8, color: T.textDim, letterSpacing: 1.2, textTransform: "uppercase", fontWeight: 600 }}>{s.label}</div>
            <div style={{ fontFamily: fonts.display, fontSize: 16, fontWeight: 400, color: s.color, marginTop: 2 }}>{s.value}</div>
          </div>
        ))}
      </div>

      <div style={{ fontSize: 12, color: T.text, marginBottom: 10 }}>{t("mock.lesson.choose")}</div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {options.map((o, i) => (
          <div key={i} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: "12px 12px", display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: 10, background: T.surface2, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: fonts.display, fontStyle: "italic", fontSize: 16, color: T.text }}>{o.letter}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: T.text }}>{t(o.titleKey)}</div>
              <div style={{ fontSize: 10, color: T.textDim, marginTop: 1 }}>{t(o.subKey)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LessonMockup;
